import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import AlertManager from 'src/components/alert/AlertManager';
import model from '../invitationsModel';
import { Avatar, MCButton, MCText } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import { BASE_ICONS } from 'src/components/svg';
import { rgba, scssVariables, validate, remCss, lang } from 'src/helpers';
import MCEditableTable, {
  EDITABLE_TABLE_ROWS_LIMIT,
  EditCell
} from 'src/components/complex/MCEditableTable';
import listModel from '../model';

export const ImportBtn = () => {
  const [uploading, setUploading] = useState(false);
  return (
    <div>
      <Dropzone
        onDropAccepted={(files) => {
          setUploading(true);
          model.sendImport({ files }, (err, data) => {
            if (data?.ok) {
              const valid = [];
              const invalid = [];
              if (data.data.length > EDITABLE_TABLE_ROWS_LIMIT) {
                AlertManager.popup(AlertManager.TYPES.INFO, {
                  close: false,
                  width: 400,
                  title: LANG_CONST.notice.sent_only_100,
                  cancelButton: {
                    label: LANG_CONST.buttons.ok,
                    action: (actions) => {
                      actions.hide();
                    }
                  }
                });
              }
              data.data.forEach((item) => {
                if (item.ok) valid.push(item);
                else invalid.push(item);
              });
              model.setState({
                bulkList: [
                  ...invalid,
                  ...valid,
                  ...Array.from(
                    { length: data.data.length > 9 ? 4 : 9 - data.data.length },
                    () => ({})
                  )
                ].slice(0, EDITABLE_TABLE_ROWS_LIMIT)
              });
            }
            setUploading(false);
          });
        }}
        accept={{
          'text/csv': ['.csv'],
          'text/vcf': ['.vcf']
        }}
        multiple={true}
      >
        {({ getRootProps, getInputProps }) => {
          const { onClick, ...rootProps } = getRootProps({
            style: {}
          });
          return (
            <div {...rootProps}>
              <input {...getInputProps()} />
              <MCButton
                label={LANG_CONST.buttons.import_invite}
                primary
                dark
                radius
                style={{ width: remCss(200) }}
                onClick={onClick}
                loading={uploading}
                disabled={uploading}
              />
            </div>
          );
        }}
      </Dropzone>
    </div>
  );
};

const Bulk = () => {
  model.use();

  const list = model.state.bulkList;

  const setList = (bulkList) => model.setState({ bulkList });
  const createState = model.getApiState('bulk');
  const { loading } = createState;

  return (
    <>
      <div
        className={'mc-container-content__body-content border'}
        style={{
          paddingTop: 0,
          paddingBottom: 0,
          gap: 0,
          borderTop: 'none',
          marginTop: remCss(-4)
        }}
      >
        <MCEditableTable
          list={list}
          setList={setList}
          onHandleChangeValid={(item, index, n, v) => {
            const name = n === 'name' ? v : item.name;
            const value = n === 'name' ? item.value : v;

            if (
              item.ok === false &&
              !validate('fullName', name) &&
              (!validate('email', value) || !validate('phoneNumber', value))
            ) {
              item.ok = true;
            }
          }}
          columns={[
            {
              cellStyles: { textAlign: 'center', padding: remCss(5), marginBottom: 0 },
              width: `${remCss(100)}px`,
              renderCell: (item, index) => (
                <div className={'mc-flex-20'}>
                  <Avatar image={item.avatar} text={item.name || ' '} width={40} height={40} />
                  <MCText label={index + 1} textLight />
                </div>
              )
            },
            {
              label: LANG_CONST.name,
              cellStyles: { padding: remCss(5), marginBottom: 0 },
              cellProps: {
                style: { padding: 0 }
              },
              name: 'name',
              renderEditCell: (editProps, item, index) => (
                <div className={'mc-flex'}>
                  <div className={'mc-p5 mc-grow'}>
                    <EditCell
                      {...editProps}
                      placeholder={
                        index === 0
                          ? lang
                              .t(LANG_CONST.text.type, {
                                attr: lang.t(LANG_CONST.name)
                              })
                              .toLowerCase()
                          : ''
                      }
                    />
                  </div>
                  <span
                    style={{
                      borderRight: `${remCss(3)}px solid ${rgba(scssVariables['colors-mc-primary'], 0.1)}`,
                      height: remCss(55),
                      width: remCss(1),
                      marginRight: remCss(50)
                    }}
                  />
                </div>
              )
            },
            {
              label: lang.t(LANG_CONST.phone_number) + '/' + lang.t(LANG_CONST.email),
              cellStyles: { padding: remCss(5), marginBottom: 0 },
              name: 'value',
              renderEditCell: (editProps, item, index) => (
                <EditCell
                  {...editProps}
                  placeholder={
                    index === 0
                      ? lang
                          .t(LANG_CONST.text.type, {
                            attr: lang.t(LANG_CONST.phone_or_email)
                          })
                          .toLowerCase()
                      : ''
                  }
                  valid={(v) => {
                    if (!v) return true;
                    if (validate('phoneNumber', v)) {
                      if (validate('email', v)) return false;
                    }
                    return true;
                  }}
                />
              )
            },
            {
              cellStyles: {
                textAlign: 'end',
                padding: remCss(5),
                marginBottom: 0
              },
              width: `${remCss(50)}px`,
              renderCell: (item, index) => (
                <MCButton
                  iconname={BASE_ICONS.CLOSE}
                  tabIndex={-1}
                  primary
                  rounded
                  disabled={list.length === 1}
                  light
                  onClick={() =>
                    list.length > 1
                      ? setList(list.filter((i, idx) => idx !== index))
                      : setList([{}])
                  }
                  small
                />
              )
            }
          ]}
        />
      </div>
      <div className={'mc-container-content__body-footer'}>
        <div className={'mc-flex'}>
          <div className={'mc-grow'}></div>
          <MCButton
            primary
            medium
            dark
            radius
            loading={loading}
            disabled={loading}
            label={LANG_CONST.buttons.send_invite}
            onClick={() => {
              model.sendBulk((err, data) => {
                if (data?.ok) {
                  listModel.refresh();
                  setList(data.data);
                  AlertManager.popup(AlertManager.TYPES.INFO, {
                    close: false,
                    width: 460,
                    title: lang.t(LANG_CONST.notice.sent_invitations, {
                      type: lang.t(LANG_CONST.manager).toLowerCase()
                    }),
                    actionButton: {
                      label: LANG_CONST.buttons.ok,
                      action: (actions) => {
                        actions.hide();
                      }
                    }
                  });
                }
              });
            }}
          />
        </div>
      </div>
    </>
  );
};

Bulk.displayName = 'Bulk';

export default Bulk;
